import { combineReducers } from 'redux';
import sessionReducer from './session';
import { reducer as reducerForm } from 'redux-form';

import employeeReducer from './employeeReducer';
import agentReducer from './agentReducer';
import visitorReducer from './visitors';
import userReducer from './userReducer';
import chitReducer from './chitReducer';
import chittiesReducer from './chittiesReducer';
import chittieAuctionReducer from './chittieAuctionReducer';
import chittiePaymentReducer from './chittiePaymentReducer';
import reportReducer from './reportReducer';
import dashboardReducer from './dashboardReducer';
import storage from 'redux-persist/lib/storage';
import pageReducer from './pageReducer';
import profileReducer from './profileReducer';

const rootReducer = combineReducers({
  sessionState: sessionReducer,
  employeeState: employeeReducer,
  agentState: agentReducer,
  visitorState: visitorReducer,
  form: reducerForm,
  userState: userReducer,
  chitState: chitReducer,
  chittiesState: chittiesReducer,
  chittieAuctionState: chittieAuctionReducer,
  chittiePaymentState: chittiePaymentReducer,
  reportState: reportReducer,
  dashboardState: dashboardReducer,
  pageState: pageReducer,
  profileState: profileReducer
});

const appReducer = (state, action) => {
  if (action.type === 'LOGOUT_COMPLETED') {
    Object.keys(state).forEach((key) => {
      storage.removeItem(`persist:${key}`);
    });
    state = undefined;
  }
  return rootReducer(state, action);
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js